import React from 'react';
import './MyMap.scss';
import './MiniBubble.scss';

export default function MiniBubble({ unit, isSelected, onUnitSelect }) {
  const handleClick = (e) => {
    e.stopPropagation();
    if (onUnitSelect) {
      onUnitSelect(unit.unit_id);
    }
  };

  const x = 10;
  const y = 10;
  const rot = unit.bearing || 0;
  const styles = {
    transform: `translate(${x}px, ${y}px) rotateZ(${rot}deg)`
  };

  return (
    <div className="popup-bubble-anchor mini-bubble" onClick={handleClick} style={{ cursor: 'pointer' }}>
      <div className={`unit popup-bubble ${isSelected ? 'selected' : ''}`} style={{ zIndex: 1000, border: isSelected ? '3px solid #007bff' : 'none' }}>
        <div><span className="bubble-label">Speed: </span><span>{unit.speed?.toFixed(1) || '0.0'} m/s</span></div>
        <div><span className="bubble-label">Bearing: </span><span>{unit.bearing?.toFixed(0) || '0'}°</span></div>
        <div className={`detail `}  >
          <div><span className="bubble-label">Altitude: </span><span>{unit.altitude?.toFixed(0) || '0'} m</span></div>
          <div><span className="bubble-label">Lat: </span><span>{unit.last_pos_latitude?.toFixed(6) || '0'}°</span></div>
          <div><span className="bubble-label">Lon: </span><span>{unit.last_pos_longitude?.toFixed(6) || '0'}°</span></div>
        </div>
      </div>
      <span className="icon-car" style={{ ...styles, color: isSelected ? '#007bff' : 'inherit', cursor: 'pointer' }}></span>
    </div>
  );
}